import type { CustomIconProps } from '../types';

const Warning = ({ width, height, color }: CustomIconProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width ?? '12'}
        height={height ?? '12'}
        viewBox="0 0 13 12"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M5.63964 2.31001C5.83793 1.95289 6.32865 1.94559 6.53658 2.29665L11.108 10.0151C11.3238 10.3794 11.0732 10.85 10.6633 10.85H1.80625C1.40306 10.85 1.1515 10.393 1.35396 10.0284L5.63964 2.31001ZM7.42585 1.72069C6.80207 0.667493 5.32992 0.689409 4.73505 1.76074L0.449367 9.47916C-0.157998 10.573 0.596685 11.9438 1.80625 11.9438H10.6633C11.8928 11.9438 12.6446 10.5322 11.9973 9.43912L7.42585 1.72069ZM5.55618 7.67434L5.27321 5.35352C5.19564 4.71732 5.46657 4.10527 6.07987 4.10527C6.69318 4.10527 6.96411 4.71732 6.88654 5.35352L6.60357 7.67434C6.56996 7.95002 6.34563 8.1566 6.07987 8.1566C5.81412 8.1566 5.58979 7.95002 5.55618 7.67434ZM5.52148 9.5947V9.54609C5.52148 9.22389 5.77126 8.9627 6.07936 8.9627C6.38747 8.9627 6.63724 9.22389 6.63724 9.54609V9.5947C6.63724 9.9169 6.38747 10.1781 6.07936 10.1781C5.77126 10.1781 5.52148 9.9169 5.52148 9.5947Z"
            fill={color ?? '#414042'}
        />
    </svg>
);

export default Warning;
